// import {html, render} from 'lit-html';

class Frontend {

  constructor () {
    this.w = window;
    this.d = this.w.document;
    this.b = this.d.getElementsByTagName("BODY")[0];
    this.h = this.d.getElementsByTagName("HTML")[0];
    this.nav = this.d.getElementById("nav");
    this.mobilenav = this.d.getElementById("primary-nav-mobile");
    this.modal = this.d.getElementById("contact-modal");
    this.footer = this.d.getElementsByTagName("FOOTER")[0];
    this.main = this.d.getElementsByTagName("MAIN")[0];
  }
 
  init() {
    this.setupModal();
    this.setupNav();
    this.adjustFooter();
    this.setUpFooterAdjust();
    this.setupContact();
    this.setupClose();
  }

  setupNav() {
      this.nav.addEventListener("click", evt => {
        this.b.classList.add("enable-transition");
        this.h.classList.toggle("nav-open");
        evt.preventDefault();
      });
  }

  setupModal() {
      this.modal.addEventListener("click", evt => {
        this.b.classList.add("enable-transition");
        this.h.classList.toggle("modal-open");
        evt.preventDefault();
      });
  }


  setupContact() {
      this.d.getElementById('contact-link').addEventListener("click", evt => {
        this.b.classList.add("enable-transition");
        this.h.classList.remove("nav-open");
        this.w.location.href = "#footercontact";
        evt.preventDefault();
      });
  }

  setupClose() {
      this.d.getElementById('close').addEventListener("click", evt => {
        this.h.classList.remove("modal-open");
        evt.preventDefault();
      });
  }


  setUpFooterAdjust() {
    this.w.addEventListener("resize", evt => {
      this.adjustFooter();
    });
  }

  adjustFooter() {
    let footerheight = this.footer.clientHeight;
      this.main.style.marginBottom = footerheight + "px";
  }

}

document.addEventListener("DOMContentLoaded", () => {
  new Frontend().init();
  // const myTemplate = html`<div>Hello World</div>`;
  // render(myTemplate, document.getElementById('test')); 
});
